import AuthService from 'Auth/services/AuthService';

export function isAdminVisitor() {
  return AuthService.takeVisitorType() === 'Admin';
}
